import React, { useState, useEffect } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import axios from "axios"

import { STATUS_AVAILABLE } from '../order/constants';
import { TransferInformation } from '../cart/index.jsx';
import { StaticListingList, Loading, Money, Address } from '../components'
import { Shipment } from "./Order/index.jsx"

const Order = () => {
    const location = useLocation()
    const [ order, setOrder ] = useState(location.data?.order)
    const { reference } = useParams()

    useEffect(() => {
        const loadOrder = async () => {
            const { data } = await axios.get('/api/orders/' + reference)
            setOrder(data)
        }

        !order && loadOrder()
    }, [])

    if (!order) {
        return <Loading type="loading" />
    }

    const availableItems = order.items.filter(({ status }) => status === STATUS_AVAILABLE);

    // Customers only see shipments that carry a tracking number: legacy
    // AfterShip rows (no status field) or created/manual carrier rows.
    // Internal lifecycle rows (creating / error / unknown_outcome / cancelled)
    // must never surface on the confirmation page.
    const visibleShipments = (order.shipments || []).filter(
        (s) => !s.status || (['created', 'manual'].includes(s.status) && s.tracking_number)
    )

    return (
        <main id='checkout' className="confirmation flex-grow-1">
            <div className="container container-center">
                { !visibleShipments.length && (
                    <>
                        <h3 className="mt-4">Order #{order.reference_number} Placed! Thank you</h3>

                        {order.total_amount > 0 && (
                            <>
                                <p className="card">
                                    { order.status === 'paid' && 'Your payment is confirmed. You will receive a tracking link when we dispatch the order.' }
                                    { order.status !== 'paid' && 'We are waiting for a confirmation of your payment.' }
                                </p>

                                { order.payment?.method === 'offline' && order.status === 'created' && (
                                    <TransferInformation amount={order.payment.amount} currency={order.payment.currency} reference={order.payment?.paymentable?.bank_transfer_code} />
                                )}
                            </>
                        )}
                    </>
                )}

                { visibleShipments.length > 0 && (
                    <Shipment shipment={visibleShipments[0]} />
                )}

                {order.shipping_address && (
                  <>
                    <h3 className="mt-4">Delivery Address</h3>

                    <section id="delivery">
                        <div className="d-flex justify-content-between card">
                            <Address
                                address={order.shipping_address}
                            />

                            <div className="d-flex flex-grow-1 align-self-center" />
                        </div>
                    </section>
                  </>
                )}

                <h3 className="mt-4">Your Order</h3>

                <div className="card">
                    <StaticListingList cart={{items: availableItems}} readOnly />

                    {order.total_amount > 0 && (
                        <div className="total d-flex justify-content-between">
                            <h3 className="align-self-center">Total:</h3>
                            {/* Order totals are denominated in the order currency (base fallback). */}
                            <Money className="align-self-center" amount={order.total_amount} currency={order.currency} />
                        </div>
                    )}
                </div>
            </div>
        </main>
    )
}

export default Order
